import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';
import {borderStyle, icon} from '#core/utils/style-utils.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generateFavoriteIcon} from '#core/application/modules/tiles/favorite-icon/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';
import {generateSearchInput} from '#core/application/modules/tiles/search/search-input.js';

export function discoverySearchFactory(PALETTE) {
    return {
        SearchDiscoveryView: {
            dialogContent: {
                style: {
                    ...resolveBackground(PALETTE.DISCOVERY_SEARCH_DIALOG_BG),
                    ...generateBorder(PALETTE.DISCOVERY_SEARCH_DIALOG_BORDER),
                },
            },
            searchInput: merge(generateSearchInput(PALETTE.DISCOVERY_SEARCH_INPUT), {
                container: {
                    base: {
                        style: {
                            height: '40px',
                            _mobile_height: '40px',
                            borderWidth: '2px',
                        },
                    },
                    active: {
                        createStackingContext: true,
                        style: {
                            _desktop_width: '100%',
                        },
                    },
                    inactive: {
                        createStackingContext: true,
                        style: {
                            _desktop_width: '100%',
                        },
                    },
                },
                spinner: {
                    image: icon(PALETTE.DISCOVERY_SEARCH_SPINNER_ICON_COLOR),
                },
            }),
            closeIcon: icon(PALETTE.DISCOVERY_SEARCH_CLOSE_ICON_COLOR),
            searchEventList: {
                spinner: {
                    image: icon(PALETTE.DISCOVERY_SEARCH_SPINNER_ICON_COLOR),
                },
                titleIcon: icon(PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_ICON_COLOR),
                title: {
                    style: PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_TEXT,
                },
                emptyText: {
                    style: PALETTE.DISCOVERY_SEARCH_EMPTY_TEXT,
                },
                item: {
                    container: {
                        style: {
                            ...resolveBackground(PALETTE.DISCOVERY_SEARCH_EVENT_ITEM_BG),
                            ...generateBorder(PALETTE.DISCOVERY_SEARCH_EVENT_ITEM_BORDER),
                        },
                    },
                    competitionName: {
                        style: PALETTE.DISCOVERY_SEARCH_EVENT_ITEM_COMPETITION_TEXT,
                    },
                    startTime: {
                        style: PALETTE.DISCOVERY_SEARCH_METADATA_TEXT,
                    },
                    eventName: {
                        style: PALETTE.DISCOVERY_SEARCH_ITEM_NAME_TEXT,
                    },
                    showAllLabel: {
                        style: PALETTE.DISCOVERY_SEARCH_EVENT_ITEM_SHOW_ALL_LABEL_TEXT,
                    },
                    selectionButton: generateOddsButton(PALETTE.DISCOVERY_SEARCH_EVENT_ITEM_ODDS_BUTTON),
                },
            },
            searchResultsList: {
                spinner: {
                    image: icon(PALETTE.DISCOVERY_SEARCH_SPINNER_ICON_COLOR),
                },
                titleIcon: icon(PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_ICON_COLOR),
                title: {
                    style: PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_TEXT,
                },
                emptyText: {
                    style: PALETTE.DISCOVERY_SEARCH_EMPTY_TEXT,
                },
                section: {
                    title: {
                        style: PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_TEXT,
                    },
                    toggleText: {
                        style: PALETTE.DISCOVERY_SEARCH_RESULTS_SECTION_TOGGLE_TEXT,
                    },
                    expandIcon: icon(PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_ICON_COLOR),
                    collapseIcon: icon(PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_ICON_COLOR),
                    row: {
                        button: {
                            style: {
                                base: {
                                    ...resolveBackground(PALETTE.DISCOVERY_SEARCH_RESULTS_ROW_BG),
                                    ...generateBorder(PALETTE.DISCOVERY_SEARCH_RESULTS_ROW_BORDER),
                                },
                            },
                        },
                        sportIcon: {
                            icon: icon(PALETTE.DISCOVERY_SEARCH_RESULTS_ROW_ICON_COLOR),
                        },
                        parentName: {
                            style: PALETTE.DISCOVERY_SEARCH_METADATA_TEXT,
                        },
                        name: {
                            style: PALETTE.DISCOVERY_SEARCH_ITEM_NAME_TEXT,
                        },
                        live: {
                            style: PALETTE.DISCOVERY_SEARCH_RESULTS_ROW_LIVE_TEXT,
                        },
                        startTime: {
                            style: PALETTE.DISCOVERY_SEARCH_METADATA_TEXT,
                        },
                    },
                },
            },
            sportsListPanel: {
                titleIcon: icon(PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_ICON_COLOR),
                title: {
                    style: PALETTE.DISCOVERY_SEARCH_SECTION_TITLE_TEXT,
                },
                sportsContainer: {
                    style: {
                        ...generateBorder(PALETTE.DISCOVERY_SEARCH_SPORTS_LIST_PANEL_BORDER),
                    },
                },
                sportPanelSection: {
                    container: {
                        style: borderStyle(0, PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SEPARATOR_COLOR, '0 0 1px'),
                    },
                    sportHeader: {
                        style: {
                            ...resolveBackground(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_HEADER_BG),
                        },
                    },
                    contents: {
                        style: {
                            ...resolveBackground(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_CONTENTS_BG),
                        },
                    },
                    sportName: {
                        style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SPORT_NAME_TEXT,
                    },
                    sportIcon: {
                        icon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SPORT_ICON_COLOR),
                    },
                    ...generateFavoriteIcon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_FAVORITE_ICON),
                    expandIcon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_CHEVRON_ICON_COLOR),
                    collapseIcon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_CHEVRON_ICON_COLOR),
                    allOfferButton: {
                        style: {
                            base: borderStyle(0, PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SEPARATOR_COLOR, '0 0 1px'),
                        },
                    },
                    allOfferIcon: {
                        icon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_ALL_OFFER_ICON_COLOR),
                    },
                    allOfferText: {
                        style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_ALL_OFFER_TEXT,
                    },
                    topCompetitions: {
                        sportGroupsListView: {
                            countryOrSportIcon: {
                                sportIcon: {
                                    icon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SPORT_ICON_COLOR),
                                },
                            },
                            listContainer: {
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                    borderRadius: '0',
                                },
                            },
                            headerText: {
                                style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SUBSECTION_TITLE_TEXT,
                            },
                            sportGroupName: {
                                style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_LIST_ITEM_TEXT,
                            },
                            locationName: {
                                style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_LOCATION_NAME_TEXT,
                            },
                        },
                    },
                    countriesList: {
                        countryOrSportIcon: {
                            sportIcon: {
                                icon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SPORT_ICON_COLOR),
                            },
                        },
                        container: {
                            style: borderStyle(0, PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SEPARATOR_COLOR, '1px 0 0'),
                        },
                        headerText: {
                            style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_SUBSECTION_TITLE_TEXT,
                        },
                        countryHeader: {
                            style: {
                                active: {
                                    ...resolveBackground(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_HIGHLIGHT_BG),
                                },
                            },
                        },
                        countryName: {
                            style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_LIST_ITEM_TEXT,
                        },
                        expandIcon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_CHEVRON_ICON_COLOR),
                        collapseIcon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_CHEVRON_ICON_COLOR),
                        leagueButton: {
                            style: {
                                hover: {
                                    ...resolveBackground(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_HIGHLIGHT_BG),
                                },
                            },
                        },
                        leagueName: {
                            style: PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_LIST_ITEM_TEXT,
                        },
                        leagueIcon: icon(PALETTE.DISCOVERY_SEARCH_SPORT_PANEL_LEAGUE_ICON_COLOR),
                    },
                },
            },
        },
    };
}
